import CompanyDetail from "../../components/CompanyDetail";
import moment from "moment";

export const COLUMNS = [
    {
        header: "Name ",
        accessor: "name",
    }
]